import { viewsetDuck } from '@/shared/ducks/viewsetDuck';

export const DEFAULT_STATE = {};

export const duck = viewsetDuck('staffOrders', '/mgmt/api/orders/');

export const useUpdateShippingAPI = (uid) => {
    return duck.useAPI(`${uid}/update-shipping/`, { suspense: false, forceEndSlash: true });
};

export const useRemoveLineItemAPI = (uid) => {
    return duck.useAPI(`${uid}/modify/remove/`, { suspense: false, forceEndSlash: true });
};

export const useAddDiscountAPI = (uid) => {
    return duck.useAPI(`${uid}/discounts/`, { suspense: false, forceEndSlash: true });
};

export const useRemoveDiscountAPI = (uid, discount_id) => {
    return duck.useAPI(`${uid}/discounts/${discount_id}`, { suspense: false, forceEndSlash: true });
};

export const useAddLineItemAPI = (uid) => {
    return duck.useAPI(`${uid}/modify/add/`, { suspense: false, forceEndSlash: true });
};

export const useModifyQuantityOfLineItemAPI = (uid) => {
    return duck.useAPI(`${uid}/modify/change-quantity/`, { suspense: false, forceEndSlash: true });
};

export const useSubstituteLineItemAPI = (uid) => {
    return duck.useAPI(`${uid}/modify/substitute/`, { suspense: false, forceEndSlash: true });
};

export const { actionTypes, actions, reducer, useAPI } = duck;

export default duck;
